import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import * as AWS from 'aws-sdk';
import { environment } from '../../../../../environments/environment';
import { MatPaginator, MatSort, MatSnackBar } from '@angular/material';
import { PackagesHttpService } from '../../../../../app/core/packages';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MixpanelService } from '../../../../services/mixpanel.service';

interface CardStatus {
	uploadProgress: number;
	matIcon: string;
	toolTip: string;
	css: string;
}

@Component({
  selector: 'kt-upload-package',
  templateUrl: './upload-package.component.html',
  styleUrls: ['./upload-package.component.css']
})
export class UploadPackageComponent implements OnInit {

	types = [
		{text: 'UI', value: 'ui'},
		{text: 'Menu', value: 'menu'},
		{text: 'VMC', value: 'aux'}
	];

	private bucket;
  	s3token;
	selectedFile;
	imgIndex;
	imgCardStatus: CardStatus[];
	isUploadStarted = false;

	keys = [];

	uploadForm: FormGroup;

	displayedColumns = ['location_name', 'm_id', 'machine_status', 'connectivity', 'actions'];

	// dataSource: MachineListDataSource;

	qParams = {};

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	files: any = [];

	mainFileName;
	wholeFile;

	s3Err = false;

	file_version;

	availableVersions = [];

	compVersions = [];

	constructor(private http: PackagesHttpService,
				private changeDetectorRefs: ChangeDetectorRef,
				private fb: FormBuilder,
				private _snackBar: MatSnackBar,
				private mixpanelService: MixpanelService) { }

	ngOnInit() {
		this.getAvailVersions();

		this.uploadForm = new FormGroup({
			file_type: new FormControl(null, [Validators.required]),
			file_version: new FormControl(null, [Validators.required]),
			file_desc: new FormControl(null),
			files_src: new FormControl(null)
		});

		this.gets3Token();

		this.mixpanelService.track(this.mixpanelService.PAGE_VIEW);
	}

	getAvailVersions() {
	  this.http.getAvailableVersions()
	  .subscribe(data => {
		console.log(data);
		  this.availableVersions = data;

		  this.changeDetectorRefs.detectChanges();
	  }, err => {
		  console.log(err);
	  });
	}

	gets3Token() {
		this.http.getS3Obj().subscribe(s3Tok => {
			this.s3token = s3Tok;
			this.s3token['region'] = environment.region;
			this.createBucketObj();
		});
	}

	onReset() {
		this.keys = [];
		this.uploadForm.reset();
		this.compVersions = [];
		this.mainFileName = null;
		this.selectedFile = null;
		this.imgCardStatus = [];
		this.files = [];
		this.changeDetectorRefs.detectChanges();
		this.getAvailVersions();
	}

	removeCompVersion(version) {
		this.availableVersions.push(version);
		this.compVersions.splice(this.compVersions.indexOf(version), 1);

	}

	addCompVersion(version) {
		this.availableVersions.splice(this.availableVersions.indexOf(version), 1);
		this.compVersions.push(version);
	}


	uploadFile(event) {
		console.log(event);
		// this.imgCardStatus = [];
		for (let index = 0; index < event.length; index++) {
			const element = event[index];
			this.files.push(element.name);
			if (!this.imgCardStatus) {
				this.imgCardStatus = [{
					matIcon: 'delete_forever',
					toolTip: 'Delete File',
					uploadProgress: 0,
					css: 'text-danger'
				}];
			} else {
				this.imgCardStatus.push({
					matIcon: 'delete_forever',
					toolTip: 'Delete File',
					uploadProgress: 0,
					css: 'text-danger'
				});
			}

		}
		this.selectedFile = event;
	}

	createBucketObj() {
		this.bucket = new AWS.S3(this.s3token);
	}

	deleteAttachment(index) {
		this.files.splice(index, 1);
	}

	onUpload() {
		this.imgIndex = 0;
		this.isUploadStarted = true;
		console.log(this.selectedFile);

		for (const imgCrd of this.imgCardStatus) {
			imgCrd.css = 'text-secondary';
			imgCrd.toolTip = 'Disabled';
		}

		if (this.uploadForm.valid) {
			this.s3upload(this.selectedFile[this.imgIndex]);
		} else {
			return;
		}

		// this.s3upload();
	}

	// s3upload() {
	// 	// this.imgCardStatus[this.imgIndex].
	// 	this.imgCardStatus[this.imgIndex].toolTip = 'In Progress';
	// 	let value = 0;
	// 	const timer = setInterval(() => {
	// 		console.log(value);
	// 		if (value === 100) {
	// 			console.log(this.imgIndex, this.imgCardStatus[this.imgIndex]);
	// 			this.imgCardStatus[this.imgIndex].matIcon = 'check';
	// 			this.imgCardStatus[this.imgIndex].toolTip = 'Success';
	// 			this.imgCardStatus[this.imgIndex].css = 'text-success';
	// 			this.changeDetectorRefs.detectChanges();
	// 			this.imgIndex++;
	// 			if (this.imgIndex < this.selectedFile.length) {
	// 				clearInterval(timer);
	// 				this.s3upload();
	// 			} else {
	// 				clearInterval(timer);
	// 				return;
	// 			}
	// 		} else {
	// 			value = value + 5;
	// 			this.imgCardStatus[this.imgIndex].uploadProgress = value;
	// 		}
	// 		this.changeDetectorRefs.detectChanges();
	// 	}, 300);
	// }

	s3upload(file) {
		console.log(this.imgIndex, file);
		this.changeDetectorRefs.detectChanges();
		const params = {
			Bucket: environment.bucket,
			Key: 'packages/' +  this.uploadForm.get('file_type').value + '/' + this.uploadForm.get('file_version').value + '/' + file.name,
			Body: file,
			ACL: 'public-read'
		};

		this.bucket.upload(params, (err, data) => {
			if (err) {
				console.log(err);
				this.imgCardStatus[this.imgIndex].matIcon = 'error';
				this.imgCardStatus[this.imgIndex].toolTip = 'Failed';
				this.imgCardStatus[this.imgIndex].css = 'text-danger';
				this.s3Err = true;
				if ((this.imgIndex + 1) < this.selectedFile.length) {
					this.imgIndex++;
					this.s3upload(this.selectedFile[this.imgIndex]);
				} else {
					this.s3ErrorHandler('One or more files, Please upload that again and click submit.');
				}
			} else {
				if (data.Key && data.Location) {
					if (file.name.includes('tar.gz') || file.name.includes('.hex')) {
						this.mainFileName = file.name;
						this.wholeFile = data.Location;
						console.log('Pushing tz/hx:', data.Key);
						this.keys.push({key: data.Key});
					} else {
						console.log('Pushing norm:', data.Key);
						this.keys.push({key: data.Key});
					}
					if ((this.imgIndex + 1) < this.selectedFile.length) {
							this.imgCardStatus[this.imgIndex].matIcon = 'check';
							this.imgCardStatus[this.imgIndex].toolTip = 'Success';
							this.imgCardStatus[this.imgIndex].css = 'text-success';
							this.imgIndex++;
							this.s3upload(this.selectedFile[this.imgIndex]);
					} else {
						this.imgCardStatus[this.imgIndex].matIcon = 'check';
						this.imgCardStatus[this.imgIndex].toolTip = 'Success';
						this.imgCardStatus[this.imgIndex].css = 'text-success';
						this.changeDetectorRefs.detectChanges();
						if (this.s3Err) {
							this.s3ErrorHandler('One or more files, Please upload that again and click submit.');
						} else {
							const upObj = {
								file_version: this.uploadForm.get('file_version').value,
								file_name: this.mainFileName,
								file_desc: this.uploadForm.get('file_desc').value,
								file_type: this.uploadForm.get('file_type').value,
								down_link: this.wholeFile,
								file_key: JSON.stringify(this.keys),
								comp: null,
								multiple: (this.selectedFile.length > 1) ? 1 : 0,
								uploaded_by: 'user' // Change when using cognito
							};
							if (this.compVersions.length > 0) {
								upObj.comp = this.compVersions.join(',');
							}
							console.log(upObj);
							this.http.cloudUploads(upObj)
							.subscribe(data1 => {
								this.s3ErrorHandler('Uploaded ' + this.mainFileName + ' Successfully!!');
								this.onReset();
							}, error => {
								console.log(error);
								this.s3ErrorHandler('Something wrong!!!. Please refresh the page and try to upload again.');
							});
						}
					}
				} else {
					this.s3ErrorHandler('Important values are missing from S3 response. Please contact support');
				}
			}
		}).on('httpUploadProgress', (evt) => {
			this.imgCardStatus[this.imgIndex].uploadProgress = +((evt.loaded * 100) / evt.total).toFixed(0);
			this.changeDetectorRefs.detectChanges();
		});
	  }

	  s3ErrorHandler(msg) {
		  let snackRef = this._snackBar.open(msg, 'close');
		  snackRef.onAction().subscribe(() => {
			snackRef.dismiss();
		  });
	  }

}
